import { customAlphabet } from 'nanoid'

const idAlphabet =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
export const idNanoid = customAlphabet(idAlphabet, 30)

export const toDomId = (id: string) => `id-${id}`
